import axios from "axios";

const qs = require("qs");
import JwtService from "../jwt-service";

axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.status_code === 404) {
      //return window.location.href = '/404';
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 404) {
      //return window.location.href = '/404';
    }

    if (error.response && error.response.status === 422) {
      return Promise.resolve(error.response);
    }

    if (error.response && error.response.status === 500) {
      return Promise.resolve(error.response);
    }

    if (error.response && error.response.status === 403) {
      return Promise.resolve(error.response);
    }

    if (error.response && error.response.status === 401) {
      return Promise.resolve(error.response);
    }

    return error;
  }
);

export const BaseApi = {
  headers(headers = {}) {
    let token = JwtService.getToken();
    if (typeof token !== "undefined" && token !== "undefined") {
      axios.defaults.headers.common["Authorization"] = token;
    }
    if (Object.keys(headers).length > 0) {
      for (let keyHeader in headers) {
        axios.defaults.headers.common[keyHeader] = headers[keyHeader];
      }
    }
    axios.defaults.headers.common["Content-Type"] = "application/json";
    axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  },

  request(type, resource, params, slug = "", headers = {}, config = {}) {
    this.headers(headers);
    params = this.parseParams(params);
    if (type === "querySerialize") {
      return this.querySerialize(resource, params, config);
    }
    if (type === "querySerializeBlobType") {
      return this.querySerializeBlobType(resource, params, config);
    }
    if (type === "query") {
      return this.query(resource, params, config);
    }
    if (type === "get") {
      return this.get(resource, slug, config);
    }
    if (type === "post") {
      return this.post(resource, params, config);
    }
    if (type === "update") {
      return this.update(resource, slug, params, config);
    }
    if (type === "put") {
      return this.put(resource, params, config);
    }
    if (type === "delete") {
      return this.delete(resource, params, config);
    }
    if (type === "refreshToken") {
      return this.refreshToken(resource, params, config);
    }
  },

  refreshToken(resource, params, config = {}) {
    axios.defaults.headers.common["AuthorizationRefreshToken"] =
      JwtService.getRefreshToken();
    return axios.post(`${resource}`, params, config);
  },

  querySerialize(resource, parameters, config = {}) {
    let configRequest = this.parseConfig(config, {
      params: parameters,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    });
    return axios.get(resource, configRequest).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  querySerializeBlobType(resource, parameters, config = {}) {
    let configRequest = this.parseConfig(config, {
      responseType: "blob",
      params: parameters,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false });
      },
    });
    return axios.get(resource, configRequest).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  query(resource, params, config = {}) {
    let configRequest = this.parseConfig(config, {
      params: params,
    });
    return axios.get(resource, configRequest).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "", config = {}) {
    return axios.get(`${resource}/${slug}`, config).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params, config = {}) {
    return axios.post(`${resource}`, params, config);
  },

  update(resource, slug, params, config = {}) {
    return axios.put(`${resource}/${slug}`, params, config);
  },

  put(resource, params, config = {}) {
    return axios.put(`${resource}`, params, config);
  },

  delete(resource, params, config = {}) {
    let configRequest = this.parseConfig(config, {
      params: params,
    });
    return axios.delete(resource, configRequest).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  parseConfig(config, baseConfig) {
    if (Object.keys(config).length > 0) {
      return { ...config, ...baseConfig };
    } else {
      return baseConfig;
    }
  },

  parseParams(params) {
    if (!params) {
      return params;
    }
    let result = {};
    if (params instanceof FormData) {
      return params;
    }
    for (let key in params) {
      if (!Object.prototype.hasOwnProperty.call(params, key)) continue;
      if (typeof params[key] === "undefined") continue;
      if (params[key] === "" || params[key] === null) continue;
      result[key] = params[key];
    }
    return result;
  },

  serialize(obj, prefix) {
    let str = [],
      p;
    for (p in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(p)) {
        let k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push(
          v !== null && typeof v === "object"
            ? this.serialize(v, k)
            : encodeURIComponent(k) + "=" + encodeURIComponent(v)
        );
      }
    }
    return str.join("&");
  },
};
